import { Label, type LabelProps } from 'labels/components/Label/Label'

export function ServerLabel(props: LabelProps) {
	return <Label {...props} />
}
